module.exports = __webpack_public_path__ + "static/media/trophy-solid-dark.951d9b2e.png";